import { createModel } from "@rematch/core";
import type { RootModel } from ".";
import { Team } from "../types/teams.types";

export interface TeamStoreProps {
    items: Team[];
    loading: {
        fetchAll: boolean;
        updateTeam: boolean;
        createTeam: boolean;
        deleteTeam: boolean;
    };
    selectedTeam: Team | null;
}

export const teamInitialState: TeamStoreProps = {
    items: [],
    loading: {
        fetchAll: false,
        updateTeam: false,
        createTeam: false,
        deleteTeam: false,
    },
    selectedTeam: null,
};

export const teams = createModel<RootModel>()({
    state: teamInitialState,
    reducers: {
        toggleLoading: (state, prop: keyof TeamStoreProps["loading"], value: boolean) => ({
            ...state,
            loading: {
                ...state.loading,
                [prop]: value,
            },
        }),
        setTeams: (state, items: Team[]) => ({
            ...state,
            items,
        }),
        createTeamInStore: (state, newTeam: Team) => ({
            ...state,
            items: [...state.items, newTeam],
        }),
        updateTeamInStore: (state, updatedTeam: Team) => ({
            ...state,
            items: state.items.map(team =>
                team.id === updatedTeam.id ? updatedTeam : team
            ),
        }),
        setSelectedTeam: (state, team: Team | null) => ({
            ...state,
            selectedTeam: team,
        }),
    },
});
